import { RadioGroup } from '@headlessui/react'
import { TicketIcon } from 'assets/icons'
import { RadioCheck } from 'views/BookPage/ui'
import { PropsWithChildren } from 'react'
import FormattedMessage from 'utils/FormattedMessage'

type Props = {
  disabled?: boolean
  value: string
  title: string
}

export const SelectablePanel = ({ children, disabled, title, value }: PropsWithChildren<Props>) => {
  return (
    <RadioGroup.Option
      value={value}
      disabled={disabled}
      className={({ checked, disabled }) => {
        // light theme
        const light = disabled
          ? 'text-gray-500 border-gray-300'
          : checked
            ? 'text-gray-900 bg-custom-secondary_selected !border-custom-secondary_border'
            : 'text-gray-900 border-gray-300 hover:border-gray-400 hover:bg-custom-secondary_hover active:bg-custom-secondary_active focus:border-gray-400'
        // dark theme
        const dark = disabled
          ? 'dark:text-gray-100 dark:border-gray-600'
          : checked
            ? 'dark:bg-custom-primary dark:text-white'
            : 'dark:text-gray-100 dark:bg-custom-secondary dark:border-gray-300 dark:hover:bg-custom-secondary_hover_dark dark:hover:border-gray-200 dark:focus:border-gray-200'
        return `relative flex cursor-pointer rounded-lg border border-solid ${light} ${dark}`
      }}
    >
      {({ checked, disabled }) => (
        <div
          className={(() => {
            // light theme
            const lightDivide = checked ? '!divide-custom-secondary_border' : 'divide-gray-300'
            // dark theme
            const darkDivide = checked ? '' : disabled ? 'dark:divide-gray-400' : 'dark:divide-gray-300'
            return `flex flex-col w-full divide-y rounded-md divide-solid ${lightDivide} ${darkDivide}`
          })()}
        >
          <div
            className={`flex w-full px-5 py-4 rounded-t-md opacity ${
              checked ? 'dark:bg-custom-primary' : ''
            }`}
          >
            <div className='flex w-full items-center'>
              <div className='mr-3 flex items-center'>
                <TicketIcon
                  className={`w-6 h-6 ${
                    disabled
                      ? 'stroke-gray-500 dark:stroke-gray-200'
                      : 'stroke-gray-900 dark:stroke-gray-100'
                  }
                `}
                />
              </div>
              <div className='flex items-center'>
                <div className='text-sm'>
                  <RadioGroup.Label
                    as='p'
                    className={`font-medium ${
                      disabled ? 'text-gray-500' : 'text-gray-900 dark:text-gray-100'
                    }`}
                  >
                    <FormattedMessage id={title} />
                  </RadioGroup.Label>
                </div>
              </div>
            </div>

            <div className='flex items-center'>
              <RadioCheck checked={checked} />
            </div>
          </div>
          <div
            className={`flex flex-col justify-center h-full items-center rounded-b-md pt-3 bg-custom-bg dark:bg-custom-secondary`}
          >
            {children}
          </div>
        </div>
      )}
    </RadioGroup.Option>
  )
}
